import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  cursor: pointer;\n  transition: color 0.3s;\n\n  input[type=\"radio\"] {\n    opacity: 0;\n    position: fixed;\n    width: 0;\n  }\n  > div {\n    display: inline-block;\n    width: 18px;\n    height: 18px;\n    margin: 0.25em 1em 0.25em 0.25em;\n    border: 2px solid ", ";\n    border-radius: 50%;\n    background: ", ";\n    vertical-align: bottom;\n    position: relative;\n  }\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from "styled-components";
import { styled } from "@styles";
var inputStyle = css(_templateObject(), function (props) {
  return props.checked ? props.theme.colors.baseFont : props.theme.colors.graySemi;
}, function (props) {
  return props.theme.colors.red;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.checked && "> div > span {\n      display: block;\n      width: 10px;\n      height: 10px;\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      border-radius: 50%;\n      background: ".concat(props.theme.colors.red, ";\n    }");
});
export var Input = styled.div(_templateObject2(), inputStyle);
export var LabeledInput = styled.label(_templateObject3(), inputStyle);